import '#/index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRouter } from '#/AppRouter';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element was not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>
);
